module.exports = __webpack_public_path__ + "img/am05.1538949a.jpg";